import { TranslatePipe } from '../../../shared/i18n/translate.pipe';
import { Component, DestroyRef, HostListener, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PartenairesComponent } from '../partenaires/partenaires';

@Component({
  selector: 'app-histoire',
  imports: [TranslatePipe, PartenairesComponent],
  templateUrl: './histoire.html',
  styleUrl: './histoire.scss',
})
export class HistoireComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly platformId = inject(PLATFORM_ID);
  openSection: 'history' | 'vision' | 'partenaires' = 'history';

  constructor() {
    if (this.route.snapshot.data['section'] === 'vision') {
      this.openSection = 'vision';
    }
    if (this.route.snapshot.data['section'] === 'partenaires') {
      this.openSection = 'partenaires';
    }
  }

  ngOnInit(): void {
    this.route.fragment
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(fragment => this.openFromFragment(fragment));
  }

  @HostListener('window:agbe:open-about-section', ['$event'])
  onMenuSectionRequest(event: Event): void {
    const fragment = (event as CustomEvent<string>).detail;
    if (typeof fragment === 'string') this.openFromFragment(fragment);
  }

  toggle(section: 'history' | 'vision' | 'partenaires'): void {
    this.openSection = section;
    const id = section === 'history' ? 'histoire' : section === 'vision' ? 'vision-valeurs' : 'partenaires';
    void this.router.navigate([], {
      relativeTo: this.route,
      fragment: id,
      replaceUrl: true
    });
    this.scrollAfterRender(id);
  }

  private openFromFragment(fragment: string | null): void {
    if (!fragment) return;

    const sectionByFragment: Record<string, 'history' | 'vision' | 'partenaires'> = {
      histoire: 'history',
      history: 'history',
      'vision-valeurs': 'vision',
      vision: 'vision',
      partenaires: 'partenaires',
      partners: 'partenaires'
    };
    const section = sectionByFragment[fragment];
    if (!section) return;

    this.openSection = section;
    const targetId = section === 'history' ? 'histoire' : section === 'vision' ? 'vision-valeurs' : 'partenaires';
    this.scrollAfterRender(targetId);
  }

  private scrollAfterRender(id: string): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Deux frames garantissent que le panneau conditionnel @if est inséré
    // et que sa hauteur est calculée avant le défilement.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
  }
}
